export const isMentionAffiliateLinkOnly = mention => {
  return !!mention.QuickLinkPin_id && !mention.Collection_id && !mention.tagFound;
};
